import { createUseStyles } from 'react-jss';

export default createUseStyles({
  container: {
    display: 'flex',
    marginBottom: '24px',
  },

  searchButton: {
    zIndex: '10',
  },

  input: {
    height: '40px',
    width: '100%',
    padding: '20px 0 20px 57px',
    borderTopRightRadius: '12px',
    borderBottomRightRadius: '12px',
    backgroundColor: '#fff',
    transition: 'border 0.15s ease-in-out',
    border: '1px solid #fff;',

    position: 'relative',
    right: '4px',

    '&:focus': {
      border: '1px solid #102131;',
      borderLeft: 'none',
      boxShadow: 'none',
    },
  },

  image: {
    position: 'absolute',
    top: '10px',
    left: '19px',
    cursor: 'text',
  },

  fixedHeight: {
    // DO NOT DELETE - IMPORTANT TO OVERLOAD DEFAUT HEIGHT:40 px; PROP
  },
});
